import React from "react";

import { getStringFromBetween, pad2 } from "shared/lib/functions";
import { isFalsy } from "shared/lib/isFalsy";

interface Props {
  duration: string;
}

interface ExtendedProps extends Props {
  showNothingIfNotDefined?: boolean;
}

const FormatDuration: React.FC<ExtendedProps> = ({
  duration,
  showNothingIfNotDefined,
}) => {
  if (showNothingIfNotDefined && (duration === "PT0H0M" || isFalsy(duration))) {
    return null;
  }

  return (
    <span>
      <b>{getStringFromBetween.get(duration, "PT", "H")}</b> h{" "}
      <b>{pad2(getStringFromBetween.get(duration, "H", "M"))}</b> min
    </span>
  );
};

export default FormatDuration;
